module.exports = __webpack_public_path__ + "static/media/earning-purple-card.2ac24e53.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/earning-purple-card.svg
// module id = 2416
// module chunks = 0